import React,{Component} from "react";
import appinfo from "../../clientsJSON";
import "../home/index.css";
import {
    Menu,
    Footer,
    ServiceCard,
    SingleProduct,
} from "../../component";

class Services extends Component {
    constructor(props){
        super(props);
        this.state={
            sId:""
        }
    }
 
    componentDidMount(){
        let Id = this.props.match.params.id;
        this.setState({sId:Id}); 
      
    }
   
    render(){
        document.title = "Products | " + appinfo.name;
        let source=""
        source=`https://development.moonproduct.in?id=${appinfo["x-access-client-id"]}&form=${appinfo["form"]}`
        let toRender = [];
        let Id=this.state.sId
        if(![undefined,null,NaN,""].includes(this.state.sId)){
            toRender = appinfo.services.content.filter(e =>{return( e.title === Id.replace("-"," "))})
        }else toRender = appinfo.services.content;
        return (
            <div>
                
                <Menu/>
                <div className="mp-container">
                {toRender.length>1&&<div><h1  style={{textAlign:"center",padding:50,textTransform:"uppercase"}}>{appinfo.services.title}</h1>
                   {toRender.map( (single,index) => {
                        return <ServiceCard content={single} index={index}/>;})}</div>}
                    
                    {toRender.length===1 && toRender.map( (single,index) => {
                        return (
                        <div>
                            <SingleProduct content={single} index={index}/>
                            {/* <iframe src={source} frameBorder="0" width="100%" height="390px"></iframe> */}
                        </div>
                    )})
                    }      
                </div>
                <Footer/>
            </div>
        )
    }    
}
export default Services;